import Galeria from '../componentes/Galeria';

export default function Fotos() {
  return (
    <Galeria
      tipo="foto"
      titulo="Fotos dos cultos"
      subtitulo="Registros de cada culto, para ver e baixar."
      vazio="Nenhuma foto publicada ainda."
    />
  );
}
